import { BadgeCheck, MessageSquareReply, Package } from "lucide-react";
import { Stars } from "@/components/Stars";
import { MediaGallery } from "@/components/Media";
import { fmtDate } from "@/lib/api";

export const ReviewCard = ({ r, index = 0 }) => (
  <article
    data-testid={`public-review-${r.id}`}
    className="bg-white border border-gray-200 rounded-lg p-6 sm:p-7 fade-up"
    style={{ animationDelay: `${Math.min(index, 8) * 60}ms` }}
  >
    <div className="flex items-start justify-between gap-4">
      <div className="flex items-center gap-3">
        <span className="h-10 w-10 rounded-full bg-emerald-900/5 border border-emerald-900/10 flex items-center justify-center font-display font-bold text-emerald-900">
          {(r.author_name || "?")[0]}
        </span>
        <div>
          <p className="font-semibold text-sm">{r.author_name}</p>
          {r.verified && (
            <p className="text-xs text-emerald-800 font-medium inline-flex items-center gap-1">
              <BadgeCheck size={13} /> {r.source === "trustedshops" ? "Importata da Trusted Shops" : "Acquisto verificato"}
            </p>
          )}
        </div>
      </div>
      <time className="text-xs text-gray-500 whitespace-nowrap">{fmtDate(r.created_at)}</time>
    </div>
    <div className="mt-5 flex items-center gap-3 flex-wrap">
      <Stars value={r.rating} size={18} />
      {r.product_name && (
        <span className="inline-flex items-center gap-1 text-xs text-gray-600 bg-gray-100 rounded-full px-2.5 py-1">
          <Package size={12} /> {r.product_name}
        </span>
      )}
    </div>
    {r.title && <h3 className="mt-3 font-display text-lg font-bold tracking-tight">{r.title}</h3>}
    <p className="mt-2 text-[15px] leading-relaxed text-gray-700 whitespace-pre-line">{r.comment}</p>
    <MediaGallery media={r.media} />
    {r.reply?.text && (
      <div className="mt-5 border-l-2 border-emerald-900 bg-gray-50 rounded-r-md px-4 py-3" data-testid={`public-review-reply-${r.id}`}>
        <p className="text-xs font-semibold text-emerald-900 inline-flex items-center gap-1">
          <MessageSquareReply size={13} /> Risposta di Rocard
        </p>
        <p className="mt-1 text-sm text-gray-700 whitespace-pre-line">{r.reply.text}</p>
      </div>
    )}
  </article>
);
